const FraudIncidentStatus = {
    PENDING : "PENDING",
    RESOLVED: "RESOLVED",
};

export default FraudIncidentStatus;
